module.exports = __webpack_public_path__ + "static/media/performancepackage.aba9279e.jpg";